
import Input from "../Input";
import Output from "../Output";

import switchImage from "../../assets/switch.png";
import { Helmet } from 'react-helmet-async';

import { Link } from "react-router-dom";
import thai from "../../assets/thai.png";
import magyar from "../../assets/magyar.png";
import arrow from "../../assets/arrow.png"

function ThaiMagyar({ handleText, output, handleTarget, handleSource, langs, handleSwap, handleTranslate, text }) {


    return (

        <>
            <Helmet>
                <title>Thai magyar fordító</title>
                <meta name='description' content="Ingyenes thai magyar fordító szavakra, kifejezésekre, mondatokra. Akár teljes szöveg fordítása is." />
                <meta title="Thai magyar fordító" />
                <link rel="canonical" href="https://online-fordito.hu/thai-magyar-fordito" />
            </Helmet>
            <h1>Thai magyar fordító</h1>
            <div className="wrapper">
                <div>
                    <Input handleText={handleText} handleSource={handleSource} langs={langs} text={text}></Input>
                    <button className="transbutton" onClick={handleTranslate}>Fordítás</button>
                </div>

                <button className="switch" onClick={handleSwap}><img src={switchImage}></img></button>


                <Output output={output} handleTarget={handleTarget} langs={langs} />

            </div>

            <section>

                <div className="sectionhead">
                    <h2>A thai nyelvről</h2>
                    <img src={thai} alt="Thai zászló"></img>
                </div>

                <p>A thai Thaiföld hivatalos nyelve, és körülbelül 75 millió ember beszéli. Ez egy tonális nyelv, amely a Tai-Kadai nyelvcsaládhoz tartozik, és egyedülálló írásáról, gazdag kulturális örökségéről és barátságos, udvarias kifejezéseiről ismert.</p>

                <p>Írásrendszere az abugida írásmódon alapul, amely a mássalhangzó-szimbólumokat diakritikus jelekkel kombinálja a magánhangzók és a hangnem jelzésére. A forgatókönyv 44 mássalhangzóból, 15 magánhangzóból és különböző hangjelzőkből áll. A thai nyelvet vízszintesen balról jobbra írják.</p>

                <p>A thai kiejtés kihívást jelenthet a nem anyanyelvi beszélők számára öt hangja miatt: magas, közepes, alacsony, emelkedő és csökkenő. A szó hangszíne befolyásolja a jelentését, így a helyes tónusú kiejtés elengedhetetlen a megértés és a megértés szempontjából.</p>

                <p>Nyelvtan viszonylag egyszerűnek tűnik, nem tartalmaz igeragozást, nemet vagy többes számot. Ehelyett a thai nyelv partikulákat, szórendet és kontextust használ a jelentés közvetítésére. A főnevek és névmások nemtől és számtól függetlenül ugyanazok maradnak. Az igéket általában alapformájukban használják, és az igét határozókon vagy kontextuson keresztül jelzik.</p>

                <p>A thai nyelvű szókincs a Tai-Kadai nyelvcsaládban gyökerezik, és kölcsönzött szavakat páliból, szanszkritból és újabban angolból és más nyelvekből is. A thai irodalomnak hosszú és nagyra becsült története van, olyan befolyásos szerzőkkel, mint Sunthorn Phu és Silpa Bhirasri. A thai kultúra sokszínű, és mélyen gyökerezik a hagyományokban, a buddhizmusban, az élénk fesztiválokon és az ízletes konyhában.</p>

                <p>Thaiföld gazdasága növekvőben van, különösen az olyan ágazatokban, mint a turizmus, a vendéglátás, a gyártás és a szolgáltatások. A thai nyelv ismerete előnyös lehet ezeken a területeken végzett karrierhez, vagy azoknak, akik érdeklődnek a thaiföldi élet, munka vagy utazás iránt.</p>

                <p>A thai nyelv ismerete lehetővé teszi a jobb kommunikációt és a kulturális elmélyülést a thai nyelvű közösségekben. Kimutatja a helyi kultúra iránti tiszteletet, és fokozza az élményeket, amikor Thaiföld gyönyörű tájait, történelmi helyszíneit fedezi fel, és barátságos emberekkel kommunikál.</p>

                <div className="sectionbottom">
                    <Link to="/magyar-thai-fordito">Magyar thai fordító</Link>

                    <img src={thai} alt="thai zászló"></img>
                    <img src={arrow} alt=">"></img>
                    <img src={magyar} alt="magyar zászló"></img>

                </div>

            </section>
        </>

    )
}

export default ThaiMagyar;